import Announcements from './components/Announcements/index';
import AnnouncementSubLayout from './sublayouts/AnnouncementSubLayout';
import Calendar from './components/Calendar/index';
import CardGroupPanel from './components/CardGroupPanel';
import CardGroupSection3Col from './components/CardGroupSection3Col';
import ContentPageCard from './components/ContentPageCard';
import ExploreCards from './components/ExploreCards/index';
import Footer from './components/Footer/index';
import GenericHero from './components/GenericHero';
import Header from './components/Header/index';
import HomeAuthenticatedHero from './components/HomeAuthenticatedHero/index';
import HomeAuthenticatedHeroClubAndDistrictCards from './components/HomeAuthenticatedHeroClubAndDistrictCards/index';
import HomeAuthenticatedHeroInfoCards from './components/HomeAuthenticatedHeroInfoCards/index';
import InfogramEmbed from './components/Infogram';
import L1Hero from './components/L1Hero';
import OneColumnCalloutPanel from './components/OneColumnCalloutPanel';
import PromotionCard from './components/PromotionCard';
import RotaryMedia from './components/RotaryMedia/index';
import RotaryMicrositeCard from './components/RotaryMicrositeCard';
import RotaryOrgCard from './components/RotaryOrgCard';
import RotaryToolCard from './components/RotaryToolCard';
import TableComponent from './components/TableComponent';
import ThreeColumnImageCallout from './components/ThreeColumnImageCallout';
import ToolsCards from './components/ToolsCards/index';
import TwoColumnGreyWrapper from './components/TwoColumnGreyWrapper';
import TwoColumnTextCallout from './components/TwoColumnTextCallout';
import L1Sublayout from './sublayouts/L1Sublayout';
import RotaryFullWidthSublayout from './sublayouts/RotaryFullWidthSublayout';
import DetailPageSublayout from './sublayouts/DetailPageSublayout';
import ColumnLayout from './components/ColumnLayout';
import RichText from './components/RichText';
import L2Sublayout from './sublayouts/L2Sublayout';
import L2Hero from './components/L2Hero';
import Video from './components/Video';
import CardGroupSection2Col from './components/CardGroupSection2Col';
import FullWidthCardCallout from './components/FullWidthCardCallout';
import CardGroupGrid from './components/CardGroupGrid';
import ColorBodyCopy from './components/ColorBodyCopy';
import ArticleCardGrid from './components/ArticleCardGrid';
import ArticleCard from './components/ArticleCard';
import ColorCard from './components/ColorCard';
import ColorCardGrid from './components/ColorCardGrid';
import RelatedLinks from './components/RelatedLinks';
import HarrisPagination from './components/Pagination';
import StandardCard from './components/StandardCard';
import AnnouncementsList from './components/AnnouncementsList';
import PullImage from './components/PullImage';
import WakeletEmbed from './components/WakeletEmbed';
import WebinarCard from './components/WebinarCard';
import WebinarsList from './components/WebinarsList';
import Accordion from './components/Accordion';
import Tabs from './components/Tabs';
import VendorsCard from './components/VendorsCard';
import Quote from './components/Quote';
import Divider from './components/Divider';
import GlobalBannerNotifications from './components/GlobalBannerNotifications';

const components = new Map();

components.set('Header', Header);
components.set('Footer', Footer);
components.set('GenericHero', GenericHero);
components.set('ThreeColumnImageCallout', ThreeColumnImageCallout);
components.set('PromotionCard', PromotionCard);
components.set('OneColumnCalloutPanel', OneColumnCalloutPanel);
components.set('TwoColumnTextCallout', TwoColumnTextCallout);
components.set('RotaryFullWidthSublayout', RotaryFullWidthSublayout);
components.set('HomeAuthenticatedHero', HomeAuthenticatedHero);
components.set('ToolsCards', ToolsCards);
components.set('TwoColumnGreyWrapper', TwoColumnGreyWrapper);
components.set('Calendar', Calendar);
components.set('RotaryMedia', RotaryMedia);
components.set(
  'HomeAuthenticatedHeroClubAndDistrictCards',
  HomeAuthenticatedHeroClubAndDistrictCards
);
components.set('Announcements', Announcements);
components.set(
  'HomeAuthenticatedHeroInfoCards',
  HomeAuthenticatedHeroInfoCards
);
components.set('ExploreCards', ExploreCards);

components.set('CardGroupSection3Col', CardGroupSection3Col);
components.set('ContentPageCard', ContentPageCard);
components.set('L1Hero', L1Hero);
components.set('RotaryMicrositeCard', RotaryMicrositeCard);
components.set('RotaryOrgCard', RotaryOrgCard);
components.set('RotaryToolCard', RotaryToolCard);
components.set('L1Sublayout', L1Sublayout);
components.set('AnnouncementSubLayout', AnnouncementSubLayout);
components.set('CardGroupPanel', CardGroupPanel);
components.set('DetailPageSublayout', DetailPageSublayout);
components.set('ColumnLayout', ColumnLayout);
components.set('RichText', RichText);
components.set('L2Sublayout', L2Sublayout);
components.set('L2Hero', L2Hero);
components.set('Video', Video);
components.set('Pagination', HarrisPagination);
components.set('PullImage', PullImage);
components.set('StandardCard', StandardCard);
components.set('AnnouncementsList', AnnouncementsList);
components.set('InfogramEmbed', InfogramEmbed);
components.set('TableComponent', TableComponent);
components.set('CardGroupSection2Col', CardGroupSection2Col);
components.set('FullWidthCardCallout', FullWidthCardCallout);
components.set('CardGroupGrid', CardGroupGrid);
components.set('ColorBodyCopy', ColorBodyCopy);
components.set('ArticleCardGrid', ArticleCardGrid);
components.set('ArticleCard', ArticleCard);
components.set('ColorCard', ColorCard);
components.set('ColorCardGrid', ColorCardGrid);
components.set('RelatedLinks', RelatedLinks);
components.set('WakeletEmbed', WakeletEmbed);
components.set('WebinarCard', WebinarCard);
components.set('WebinarsList', WebinarsList);
components.set('Accordion', Accordion);
components.set('Tabs', Tabs);
components.set('VendorsCard', VendorsCard);
components.set('Quote', Quote);
components.set('Divider', Divider);
components.set('GlobalBannerNotifications', GlobalBannerNotifications);

export default function componentFactory(componentName) {
  return components.get(componentName);
}
